<script setup>
import ProfileTimezoneSetting from '@/js/core/components/pages/profile/ProfileTimezoneSetting.vue';
import ProfileVisibilitySetting from '@/js/core/components/pages/profile/ProfileVisibilitySetting.vue';

defineProps({
  visibility: {
    type: Object,
    default: () => ({}),
  },
  timezone: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <div class="profile-page_profile-grid-container">
    <ul class="profile-page_profile-grid">
      <ProfileVisibilitySetting :visibility="visibility" />
      <ProfileTimezoneSetting :timezone="timezone" />
    </ul>
  </div>
</template>
